module.exports = __webpack_public_path__ + "static/media/LogicLever6_1_row_3.fb63a183.png";